<template>
  <BreadCrumb PageTitle="Users List" />
  <UsersList />
</template>

<script lang="ts">
import { defineComponent } from "vue";

import BreadCrumb from "../../template-components/Common/BreadCrumb.vue";
import UsersList from "../../template-components/Users/UsersList/UsersList.vue";

export default defineComponent({
  name: "UsersListPage",
  components: {
    BreadCrumb,
    UsersList,
  },
});
</script>